export class AtlMultiTabChangeEvent extends CustomEvent<{ tabId: string }> {
   static EVENT_NAME = 'atlantis-multi-tab-change';

   constructor(detail: { tabId: string }) {
      super(AtlMultiTabChangeEvent.EVENT_NAME, {
         detail,
         bubbles: true,
         composed: true,
      });
   }
}
